export default __webpack_public_path__ + "static/media/trainingMd.c546d668.png";